<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            资金统计
        </div>
        <div style="padding: 20px;">
            <div>
              <div v-if="showModal" class="mask">
                <div class="lodingsIcon">
                  <i class="el-icon-loading"></i><span>正在处理，请等待。。。</span>
                </div>
              </div>
                <el-row>
                    <div style="float:right">
                        <span class="demonstration">起止时间：</span>
                        <el-date-picker
                            ref="picker"
                            v-model="datetimerangeValue"
                            type="daterange"
                            :clearable='false'
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width:250px;margin-right:20px">
                        </el-date-picker>
                        <el-button type="success" icon="el-icon-download" style="margin-right:10px" @click="download">导出</el-button>
                        <el-button type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
                    </div>
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>
                    <el-table
                        :data="tableData1"
                        border
                        v-loading="loading"
                        style="width: 100%;">
                        <el-table-column prop="nowDate" label="结算日期"></el-table-column>
                        <el-table-column prop="nowDate" :formatter="sttime" label="清算周期"></el-table-column>
                        <el-table-column prop="money" :formatter="jgou" label="发卡机构"></el-table-column>
                        <el-table-column prop="money" :formatter="shanghu" label="商户"></el-table-column>
                        <el-table-column prop="money" :formatter="shanghu" label="卡类型"></el-table-column>
                        <el-table-column prop="clearingNumber" label="清算笔数"></el-table-column>
                        <el-table-column prop="totalTransactions" label="交易总额"></el-table-column>
                        <el-table-column prop="totalCommission" label="手续费总额"></el-table-column>
                        <el-table-column prop="totalSettlement" label="结算金额"></el-table-column>
                        <el-table-column prop="totalPractical" label="实际结算金额"></el-table-column>
                    </el-table>
                </template>
                <template>
                    <el-table :data="tableData" v-loading="loading" max-height="500" border style="width: 100%;margin-top:30px"  show-summary :summary-method="getSummaries">
                        <el-table-column prop="name" label="服务类型"></el-table-column>
                        <el-table-column prop="totalServe" label="服务人次统计"></el-table-column>
                        <el-table-column prop="recycleMoney" label="资金回收统计"></el-table-column>
                    </el-table>

                </template>
            </div>

        </div>
    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    // import elSelectTree from "../../components/ElSelectTree"
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
              showModal:false,
                loading:false,
                tableData:null,
                tableData1:null,
                totalItems: 0,
                pageSize:20,
                imgUrl:this.$imgUrl,
                currentPage:1,
                zoneValue:[],
                datetimerangeValue:[],
                zoneCode:'',
                th:0,
                name:'',
                zoneProps:{
                    emitPath:false,
                    value: 'zoneCode',
                    // 显示的文字字段名
                    label: 'name',
                    // 子层级字段名
                    children: 'listZoneDTO'
                },
            }
        },
        components:{
            // elSelectTree
        },
        created(){
            this.init();
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            init(){


                // const end = new Date();
                // const start=new Date(end - 1000 * 60 * 60 * 24 * 365);
                var  a =timefilters(new Date()).slice(0,7)
                var  end =new Date(new Date(a)-1000 * 60 * 60 * 24);

                const start = new Date(a).setMonth(new Date(a).getMonth() - 1);


                this.datetimerangeValue=[start, end];
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Zone/ListForStaff",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            var data=JSON.stringify(response.data.data);
                            data=JSON.parse(data.replace(/"listZoneDTO":\[\],/g,''))
                            this.zoneValue = data;
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },
            sttime(row){
                return row.startTime+'--'+row.endTime
            },
            jgou(){
                return '合肥经济技术开发区社区管理局'
            },
            shanghu(){
                return '养老卡'
            },
            download(){
                this.$confirm('是否导出当前列表?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.showModal=true
                    var that=this
                    this.$axios.get(this.$shopUrl+'ExportOldest/GetFund',{
                        responseType: 'blob',
                        params:{
                            timeStr: timeStr,
                            sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                            staffCode: getStaffCode(),
                            startTime:timefilters(this.datetimerangeValue[0]),
                            endTime:timefilters(this.datetimerangeValue[1]),
                        }
                    }).then(
                        (response) => {
                            if(response.data.type=='application/json'){
                                console.log(response)
                                this.$message({type: 'info', message: '暂无数据'});
                                that.showModal=false;
                            }else{
                                let fileName = '资金表.xlsx';
                                that.file(response,fileName);
                                that.showModal=false;
                            }
                           
                        }
                    )
                    this.dialogFormVisible=false    
                }).catch(e=>e)
            },
            file(response,fileName){
                let blob = new Blob([response.data]);
                if (window.navigator.msSaveOrOpenBlob) {
                    navigator.msSaveBlob(blob,fileName);
                } else {
                    let elink = document.createElement("a");
                    elink.download = fileName;
                    elink.style.display = "none";
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href);
                    document.body.removeChild(elink);
                }
            },
             getZoneValue(val){
                this.zoneCode=val
            },
            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            timefilter(row, column, cellValue){
                return timefilters(cellValue)
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(isSearch){
                if(isSearch)this.currentPage=1
              this.loading=true;
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"ExportOldest/GetFundPage",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                        startTime:timefilters(this.datetimerangeValue[0]),
                        endTime:timefilters(this.datetimerangeValue[1])
                    }
                }).then( (response)=> {
                    console.log(response);
                    if(response.data.error == 0){
                        var data=response.data.data
                        this.tableData =data.goodsList;
                        console.log(this.tableData)
                        var list=[];
                        data.goodsClassList=''
                        data.goodsList=''
                        list.push(data);
                        this.tableData1 =list;
                        console.log(this.tableData1)
                       this.loading=false;
                        // this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '总计';
                    return;
                }
                const values = (data || []).map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                    const value = Number(curr);
                    if (!isNaN(value)) {
                        return prev + curr;
                    } else {
                        return prev;
                    }
                    }, 0);
                    if(index==1){
                        sums[index] += ' 人';
                    }else{
                        sums[index] += ' 元';
                    }
                    
                } else {
                    sums[index] = 'N/A';
                }
                });

                return sums;
            },
            statusTitle(row){
                if(row.status == 0){
                    return "正常";
                }
                if(row.status == 1){
                    return "禁用";
                }
                return "其它";
            },



        }
    }
</script>

<style lang="scss" scoped>
.mask {
  background-color: rgb(0, 0, 0);
  opacity: 0.3;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 199
}

.mask .lodingsIcon{
  /* margin-top: 47vh; */
  margin: 47vh auto;
  height: 6vh;
  width: 300px;
  font-size: 18px;
  color: white;
}
.lodingsIcon i{
  z-index: 200;
  font-size: 25px;
  margin-right:10px ;
}


</style>
